export default __webpack_public_path__ + "static/media/logo.64322077.png";